document.addEventListener('DOMContentLoaded', function () {
    // Delay running the script by 1 second (1000 milliseconds)
    setTimeout(function () {
       document.querySelectorAll('.grid-item').forEach(productGrid => {
    productGrid.querySelectorAll('.product-card-swatches').forEach(item => {
        item.querySelectorAll('.product-card-swatch').forEach(card => {
            card.addEventListener('click', function(e){
                console.clear();
                console.log('checking');
                e.preventDefault();
                e.stopPropagation();
                item.querySelectorAll('.product-card-swatch').forEach(card => {
                    card.classList.remove('active');
                })
                this.classList.add('active');
                let productTitle = card.dataset.productHandle;
              console.clear();
                console.log(card, 'swatchProduct');
                let productUrl = `https://karenmizrahi.co.il/products/${productTitle}.js`;
                fetch(productUrl)
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok ' + response.statusText);
                    }
                    return response.json();
                })
                .then(data => {
                    console.log('Product Information:', data);
                      // console.clear();
                    console.log(data.url, data.title, data.price);
                    let titleElement = this.closest('.grid-item').querySelector('.product-item__title');
                    let priceElement = this.closest('.grid-item').querySelector('.product-item__price');
                    let linkToElement = this.closest('.grid-item').querySelectorAll('.product-link');
                    let mainImage = this.closest('.grid-item').querySelector('.product-item__bg img');
                    let quickAddItem = this.closest('.grid-item').querySelector('input[type="hidden"][name="id"]');
                    let secondaryImages = this.closest('.grid-item').querySelectorAll('.product-item__bg__under .product-item__bg__slider figure');

                    // quickAddItem.value = data.variants[0]['id'];
                    console.log(data.images[0], data.images[1]);
                    if (titleElement) {
                        titleElement.textContent = data.title;
                    }
                    let price = (data.price/100).toFixed(2);
                    if(data.price_varies){
                        priceElement.innerHTML = `<span>From NIS</span>${price}`
                    }else{
                        priceElement.innerHTML = `NIS${price}`
                    }
                    linkToElement.forEach(link => {
                        link.href= data.url;
                    });
                    let mainImageFigure = this.closest('.grid-item').querySelector('.product-item__bg figure');
                    let currentImage = mainImageFigure.querySelector('img');
                    if (currentImage) {
                      currentImage.remove();
                  }
                  let newImage = document.createElement('img');
                  newImage.src = data.images[0];
                  mainImageFigure.appendChild(newImage);

                  secondaryImages.forEach(slider => {

                    let currentImages = slider.querySelectorAll('img');
                    currentImages.forEach(img => img.remove());


                    let newImage = document.createElement('img');
                    newImage.src = data.images[1];


                    slider.appendChild(newImage);
                });
              })
                .catch(error => {
                    console.error('There was a problem with the fetch operation:', error);
                });
            })
        })
    })

    productGrid.addEventListener('mouseover', function(){
        if(productGrid.querySelector('.product-card-swatches--container'))
            productGrid.querySelector('.product-card-swatches--container').classList.add('active');
    })

    productGrid.addEventListener('mouseleave', function(){
        if(productGrid.querySelector('.product-card-swatches--container'))
            productGrid.querySelector('.product-card-swatches--container').classList.remove('active');
    })
})
    }, 1000); // Adjust the delay time if needed
});

console.log('Product Page');
    document.querySelectorAll('.product__content').forEach(productGrid => {
        productGrid.querySelectorAll('.product-card-swatches').forEach(item => {
            item.querySelectorAll('.product-card-swatch').forEach(card => {
                card.addEventListener('click', function(e){
                    e.preventDefault();
                    e.stopPropagation();
                    item.querySelectorAll('.product-card-swatch').forEach(card => {
                        card.classList.remove('active');
                    })
                    this.classList.add('active');
                    let productTitle = card.dataset.productHandle;
                    console.log(productTitle, 'swatchProduct');
                    let productUrl = `https://karenmizrahi.co.il/products/${productTitle}.js`;
                    fetch(productUrl)
                    .then(response => {
                        if (!response.ok) {
                            throw new Error('Network response was not ok ' + response.statusText);
                        }
                        return response.json();
                    })
                    .then(data => {
                      console.log(data);
                      window.location.replace('https://karenmizrahi.co.il/' + data.url);

                      // changeURLWithoutReload(data.url);
                      // let breadcrumbs = this.closest('.product__content').querySelector('.breadcrumbs span:last-child');
                      // let product__title = this.closest('.product__content').querySelector('.product__title span');
                      // let priceElement = this.closest('.product__content').querySelector('.product__price');
                      // let secondaryImages = this.closest('.product__page').querySelectorAll('.product__slide.media--hidden figure');
                      // let mainImageFigure = this.closest('.product__page').querySelector('.product__slide.media--active figure');
                      // let description = this.closest('.product__page').querySelector('div#shopify-block-ASG4yT2MvTlNDOGxnM__wishlist_engine_product_page_f6A98P+div');
                      //     console.log(data.description); // Check if it's null or undefined
                      //     if (description) {
                      //         description.innerHTML = data.description;
                      //     } else {
                      //         console.log('Tab content element not found');
                      //     }
                      //     let checkout = this.closest('.product__content').querySelector('shopify-accelerated-checkout');
                      //     let quickAddItem = this.closest('.product__content').querySelector('input[type="hidden"][name="id"]');
                      //     let quickAddItemProduct = this.closest('.product__content').querySelector('input[type="hidden"][name="product-id"]');
                      //     if (quickAddItem) {
                      //       quickAddItem.value = data.variants[0]['id'];
                      //     }
                      //     if (quickAddItemProduct) {
                      //       quickAddItemProduct.value = data.variants[0]['id'];
                      //     }
                                
                          
                          
                      //     if (checkout) {
                      //       checkout.setAttribute('variant-params', JSON.stringify([{
                      //           id: data.variants[0]['id'],
                      //           requiresShipping: true
                      //       }]));
                      //     }
                          
                      //     if (product__title) {
                      //       product__title.textContent = data.title;
                      //   }
                      // if (breadcrumbs) {
                      //   breadcrumbs.textContent = data.title;
                      // }
                        
                      //   let price = (data.price/100).toFixed(2);
                      //   if(data.price_varies){
                      //       priceElement.innerHTML = `<span>From NIS</span>${price}`
                      //   }else{
                      //       priceElement.innerHTML = `NIS${price}`
                      //   }
                      //   let currentImage = mainImageFigure.querySelector('img');
                      //   if (currentImage) {
                      //       currentImage.remove();
                      //   }
                      //   let newImage = document.createElement('img');
                      //   newImage.src = data.images[0];
                      //   mainImageFigure.appendChild(newImage);

                      //   secondaryImages.forEach((slider, index) => {
                      //       let newIndex = index + 1;
                      //       let currentImages = slider.querySelectorAll('img');
                      //       currentImages.forEach(img => img.remove());
                      //       if (data.images[newIndex]) {
                      //           let newImage = document.createElement('img');
                      //           newImage.src = data.images[newIndex];
                      //           slider.appendChild(newImage);
                      //       }
                      //   });
                      //   document.querySelectorAll('.product__slide.media--hidden').forEach(slide => {
                      //       let image = slide.querySelector('img');
                      //       if (image) {

                      //           slide.classList.remove('hiddenClass'); 
                      //       } else {

                      //           slide.classList.add('hiddenClass'); 
                      //       }
                      //   });


                    })
                    .catch(error => {
                        console.log('There was a problem with the fetch operation:', error);
                    });
                });
});
});

productGrid.addEventListener('mouseover', function(){
    if(productGrid.querySelector('.product-card-swatches--container'))
        productGrid.querySelector('.product-card-swatches--container').classList.add('active');
});

productGrid.addEventListener('mouseleave', function() {
    if(productGrid.querySelector('.product-card-swatches--container'));
    productGrid.querySelector('.product-card-swatches--container').classList.remove('active');
});
});
function changeURLWithoutReload(newURL) {
  window.history.pushState({}, '', newURL);
}


